import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";

// Cache container and shared variables
const container = document.getElementById("id_canvasdiv");
let canvas, renderer, scene, camera, mixer, clock, animationId;

// Initialize or remount the entire Three.js setup
function init() {
  // Dispose previous renderer and cancel animation
  if (renderer) {
    cancelAnimationFrame(animationId);
    renderer.dispose();
  }
  // Detect screen size and determine scale
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const isMobile = screenWidth <= 768;
  const isLarge = screenWidth >= 1024;
  // Remove old canvas and create a new one (full remount)
  container.innerHTML = "";
  canvas = document.createElement("canvas");
  canvas.id = "id3DCanvas";
  container.appendChild(canvas);
  // New clock for animations
  clock = new THREE.Clock();
  // Create scene
  scene = new THREE.Scene();
  // Add lights
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
  scene.add(ambientLight);
  const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
  directionalLight.position.set(5, 10, 7.5);
  scene.add(directionalLight);
  const pointLight1 = new THREE.PointLight(0xffffff, 0.8);
  pointLight1.position.set(-5, 5, 5);
  scene.add(pointLight1);
  const pointLight2 = new THREE.PointLight(0xffffff, 0.8);
  pointLight2.position.set(5, -5, 5);
  scene.add(pointLight2);

  // Add additional fill light for softer lighting
  const fillLight = new THREE.DirectionalLight(0xff00ff, 0.2);
  fillLight.position.set(-5, -5, 5);
  scene.add(fillLight);

  // Create renderer attached to existing canvas
  renderer = new THREE.WebGLRenderer({ antialias: true, canvas });
  renderer.setClearColor("#252525");
  const width = canvas.clientWidth;
  const height = canvas.clientHeight;
  renderer.setSize(width, height);

  // Create camera
  camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
  // Position camera farther back based on screen size
  // Adjust camera distance to balance size
  const cameraZ = 5;
  camera.position.z = cameraZ;
  // Make sure camera targets center
  camera.lookAt(0, 0, 0);

  // Load GLB model
  const loader = new GLTFLoader();
  loader.load(
    "https://cdn.shopify.com/3d/models/189a891cd8785764/v8.glb",
    (gltf) => {
      // Rotate and scale
      gltf.scene.rotation.y = -Math.PI / 2;
      const scaleVal = isMobile ? 4 : isLarge ? 7 : 6;
      gltf.scene.scale.set(scaleVal, scaleVal, scaleVal);
      // Center model pivot
      const bbox = new THREE.Box3().setFromObject(gltf.scene);
      const center = bbox.getCenter(new THREE.Vector3());
      gltf.scene.position.sub(center);
      scene.add(gltf.scene);
      mixer = new THREE.AnimationMixer(gltf.scene);
      mixer.timeScale = 0.5;
      gltf.animations.forEach((clip) => mixer.clipAction(clip).play());
    },
    undefined,
    (error) => console.error("Error loading model:", error)
  );

  // Start rendering loop
  animate();
}

function animate() {
  animationId = requestAnimationFrame(animate);
  const delta = clock.getDelta();
  if (mixer) mixer.update(delta);
  renderer.render(scene, camera);
}

// Initial mount
init();

// Debounced remount on width-change only
let lastScreenWidth = window.innerWidth;
let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const newWidth = window.innerWidth;
    if (newWidth !== lastScreenWidth) {
      lastScreenWidth = newWidth;
      init();
    }
  }, 200);
}); 